import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import * as CrmActions from '@zayan-erp/stores';
import { AppState } from '../../store/app.reducers';

export const crmResolver: ResolveFn<void> = () => {
  const store = inject(Store<AppState>);
  // Lookup data
  store.dispatch(CrmActions.loadContactSources());
  store.dispatch(CrmActions.loadLeadStatuses());
  store.dispatch(CrmActions.loadLifecycleStages());
  store.dispatch(CrmActions.loadHomeTypes());
  store.dispatch(CrmActions.loadCommunityOptions());
  store.dispatch(CrmActions.loadDealStages());
  store.dispatch(CrmActions.loadOwners());
  store.dispatch(CrmActions.loadIndustries());
  store.dispatch(CrmActions.loadTicketStages());
  // Entity lists — loaded once per session, cached in store
  store.dispatch(CrmActions.loadContacts());
  // Deals are dispatched directly by CrmDealsComponent on open (no-cache,
  // fresh fetch each visit), so they are intentionally NOT pre-loaded here.
};
